<template>
  <nav class="mobile-nav" aria-label="모바일 빠른 메뉴">
    <router-link
      v-for="item in items"
      :key="item.label"
      :to="item.to"
      class="mobile-nav__item"
      :class="{ 'is-active': isActive(item.to) }"
    >
      <AppIcon class="mobile-nav__icon" :icon="item.icon" :size="22" />
      <span class="mobile-nav__label">{{ item.label }}</span>
    </router-link>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import { useMemberAuth } from '@/composables/useMemberAuth'

const route = useRoute()
const { isLoggedIn } = useMemberAuth()

const items = computed(() => [
  { label: '홈', icon: 'mdi-home-outline', to: '/' },
  { label: '함우리몰', icon: 'mdi-storefront-outline', to: '/mall' },
  {
    label: isLoggedIn.value ? 'MY' : '로그인',
    icon: 'mdi-account-circle-outline',
    to: isLoggedIn.value ? '/my-info' : '/login',
  },
])

const SECTION_PATHS: Record<string, string[]> = {
  '/': ['/'],
  '/mall': ['/mall'],
}

function isActive(to: string): boolean {
  const group = SECTION_PATHS[to]
  if (group) {
    return group.some((path) => route.path === path || route.path.startsWith(`${path}/`))
  }
  return route.path === to || route.path.startsWith(`${to}/`)
}
</script>

<style lang="scss" src="./MobileBottomNav.scss"></style>
